module.exports = __webpack_public_path__ + "img/TheMix_cls_TT7_sc_.efb1bc69.svg";